module.exports = "/v2/pages/dashboard/dist/6662e61c57c2c17369120ab60b76bb9b.svg";